'use strict';

var react = require('react');

/**
 * A lifecycle hook that's only executed in development. It has the same signature as useEffect.
 */
const useDevelopmentEffect = (effect, deps) => {
    if (process.env.NODE_ENV === 'development') {
        // should be safe to ignore as NODE_ENV can't change dynamically
        // eslint-disable-next-line react-hooks/rules-of-hooks
        react.useEffect(effect, deps);
    }
};

exports.useDevelopmentEffect = useDevelopmentEffect;
//# sourceMappingURL=useDevelopmentEffect-DGG0KnB_.js.map
